
import { TextShow } from 'Utils/Helpers/TextShow';
import { useSelector } from 'react-redux';
import Box from '../Box';
import DeletePos from './delete';
import EditPos from './edit';

export default function ListBanks() {
  const { pos } = useSelector((state) => ({
    pos: state.setting.pos,
  }));
  return (
    <Box
      title={"دستگاه‌های ثبت شده"}
      body={
        (pos && pos.length !== 0)
        ? <>
          {
            pos.map(items => {
              return(
                <div className='box-types'>
                  <div className='flex-column-center-start'>
                    <TextShow
                      title={"عنوان :"}
                      data={items.name}
                      className={'no-hide text-muted'}
                    />
                  </div>
                  <div className='actions'>
                    <EditPos
                      id={items.id}
                      title={items.name}
                    />
                    <DeletePos
                      id={items.id}
                      title={items.name}
                    />
                  </div>
                </div>
              )
            })
          }
        </> : <div className='w-100 text-center pb-2'>
          <small>{"دستگاهی ثبت نشده"}</small>
        </div>
      }
    />
  );
}